import axios from 'axios';
import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import toast, { Toaster } from 'react-hot-toast';

const AddCarDetails = () => {
    const { register, handleSubmit, reset } = useForm();
    const onSubmit = data => {
        console.log(data);
        axios.post('https://safe-crag-22535.herokuapp.com/availableCars', data)
            .then(res => {
                if (res.data.insertedId) {
                    toast.success('Car Details Successfully Uploaded')
                    reset();
                }
            })
    }
    return (
        <div>
            <h2>Add a Service</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-main" style={{ borderRadius: "15px", maxWidth: '85rem' }}>
                    <Row>
                        <Col style={{ width: '550px', margin: '0 auto' }} md={12} xs={12} className="pr-md-4">
                            <Row>
                                <Col md={6} sm={12}>
                                    <input
                                        className="our-form-input"
                                        type="text"
                                        defaultValue=""
                                        {...register("serviceName", { required: true })}
                                        placeholder="Service Name"
                                    />
                                </Col>
                                <Col md={6} sm={12}>
                                    <input
                                        type="text"
                                        className="our-form-input"
                                        defaultValue=""
                                        {...register("serviceIcon", { required: true })}
                                        placeholder="Service Icon Link"
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} sm={12}>
                                    <input
                                        className="our-form-input"
                                        type="text"
                                        defaultValue=""
                                        {...register("img", { required: true })}
                                        placeholder="Service Image Link"
                                    />
                                </Col>
                                <Col md={6} sm={12}>
                                    <input
                                        className="our-form-input"
                                        type="text"
                                        defaultValue=""
                                        {...register("tags", { required: true })}
                                        placeholder="Enter some tags"
                                    />
                                </Col>
                            </Row>
                            <label>Service Details</label>
                            <textarea
                                type="textarea"
                                style={{ height: '150px' }}
                                className="our-form-input"
                                defaultValue=""
                                {...register("about", { required: true })}
                                placeholder="Enter Service Details"
                            />
                            <br />
                            {/* <Button type="submit">Send</Button> */}
                        </Col>
                    </Row>
                </div>

                <div className="text-center mt-4">
                    <Button type="submit" className="btn-main" style={{ padding: ".68rem 2rem" }}>
                        Submit
                    </Button>
                </div>
                <Toaster />
            </form>
        </div>
    );
};

export default AddCarDetails;